import React from 'react';
import { TranslationKey } from './../../../types/translation/TranslationKey';
import { translate } from '../../../types/translation/Translator';
import { Route, Routes } from 'react-router-dom';
import { EntityType } from '../../../types/comment';
import { CustomFieldEntityType } from '../../../types/custom_field';
import { AssetTableSettingsColumn } from '../../../types/table_settings/asset/AssetTableSettings';
import TableSettingsView from '../../shared/TableSettings/TableSettingsView';
import AssetExportConfigurationSettingsPane from './Settings/Export/AssetExportConfigurationSettingsPane';
import CreateAssetExportConfigurationPane from './Settings/Export/Panes/CreateAssetExportConfigurationPane';
import UpdateAssetExportConfigurationPane from './Settings/Export/Panes/UpdateAssetExportConfigurationPane';
import { Routing } from '../../../util/routes.util';
import { AssetOverviewCrumb, AssetSettingsCrumb, Breadcrumbs } from '../../components/Breadcrumbs';
import { Tab, Tabs } from '../../components/Tabs';

const tabs = [
  {
    text: translate({ key: TranslationKey.reporting }),
    path: Routing.assets.settings.report.overview(),
    key: 'report',
  },
  {
    text: translate({ key: TranslationKey.tableSettings }),
    path: Routing.assets.settings.tableSettings.overview(),
    key: 'table',
  },
];

export default function AssetSettingsScreen() {
  return (
    <div className='flex h-full flex-col overflow-hidden'>
      <Breadcrumbs>
        <AssetOverviewCrumb />
        <AssetSettingsCrumb current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          <Tab
            text={translate({ key: TranslationKey.reporting })}
            path={Routing.assets.settings.report.overview()}
            key={'report'}
          />
          <Tab
            text={translate({ key: TranslationKey.tableSettings })}
            path={Routing.assets.settings.tableSettings.overview()}
            key={'table'}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route path='report/*' element={<AssetExportConfigurationSettingsPane />} />
            <Route path='report/create' element={<CreateAssetExportConfigurationPane />} />
            <Route path='report/update/:id' element={<UpdateAssetExportConfigurationPane />} />
            <Route
              path='table'
              element={
                <div className='content-x'>
                  <TableSettingsView<AssetTableSettingsColumn>
                    type={EntityType.asset}
                    customFieldEntityType={CustomFieldEntityType.asset}
                    availableColumns={Object.values(AssetTableSettingsColumn)}
                    columnTextBuilder={item => translate({ key: item })}
                    label={translate({ key: TranslationKey.addAssetColumn })}
                    placeholder={translate({ key: TranslationKey.addAssetColumn })}
                  />
                </div>
              }
            />
            <Route path='*' element={<AssetExportConfigurationSettingsPane />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
